
import { Mail } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";

interface CompanySectionProps {
  companyName: string;
  notificationEmail: string;
  onCompanyNameChange: (value: string) => void;
  onNotificationEmailChange: (value: string) => void;
}

export const CompanySection = ({
  companyName,
  notificationEmail,
  onCompanyNameChange,
  onNotificationEmailChange,
}: CompanySectionProps) => {
  const { t } = useTranslation("profile");
  
  return (
    <div className="space-y-8">
      <div className="grid gap-8 md:grid-cols-2">
        <div className="space-y-3">
          <Label htmlFor="company_name" className="text-sm font-medium text-gray-700">
            {t("company.name")}
          </Label>
          <Input
            id="company_name"
            value={companyName || ""}
            onChange={(e) => onCompanyNameChange(e.target.value)}
            placeholder={t("company.namePlaceholder")}
            className="border-primary/20 focus:border-primary"
          />
        </div>
        
        <div className="space-y-3">
          <Label htmlFor="notification_email" className="text-sm font-medium text-gray-700 flex items-center gap-2">
            <Mail className="h-4 w-4 text-primary" />
            {t("notifications.email")}
          </Label>
          <Input
            id="notification_email"
            type="email"
            value={notificationEmail || ""}
            onChange={(e) => onNotificationEmailChange(e.target.value)}
            placeholder={t("notifications.emailPlaceholder")}
            className="border-primary/20 focus:border-primary"
          />
        </div>
      </div>
    </div>
  );
};
